import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=f74e7966&scoped=true"
import script from "./ProductActions.vue?vue&type=script&lang=js"
export * from "./ProductActions.vue?vue&type=script&lang=js"
import style0 from "./ProductActions.vue?vue&type=style&index=0&id=f74e7966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74e7966",
  null
  
)

export default component.exports